import { RootState } from '../../../applicationStore';
import { OrderCountersState } from '../reducers';
import { createSelector } from '@reduxjs/toolkit';

export const getOrderCountersState = (state: RootState): OrderCountersState =>
  state.orderCounters;

export const getOrderCountersLoader = createSelector(
  getOrderCountersState,
  (state): boolean => state.loading,
);

export const getOrderCountersData = createSelector(
  getOrderCountersState,
  (state): OrderCountersState['data'] | null => state?.data || [],
);
